export const COLORS = {
    "Brain Freeze": "#D5F8FE",
    "Brain Freeze Dark": "#20B3D2",
    "Capri Sun": "#FEDECE",
    "Capri Sun Dark": "#CD4C08",
    "Mint Green": "#E5F3E5",
    "Mint Green Dark": "#A6CEA6",
    "Hot Pink": "#FAE5FA",
    "Hot Pink Dark": "#C288C9",
    "Black": "#070A26"
}